import { useQuery } from "@apollo/client"
import { client } from "../../graphql/contentful/client"
import { gql } from "@apollo/client"

export const QUERY_ABOUT_PAGE = gql`
  query aboutPageContent {
    aboutpageCollection(limit: 1) {
      items {
        firstAboutContent
        firstAboutTitle
        firstAboutImage {
          url(transform: { width: 2400, quality: 70 })
        }
        quote
        quoteTitle
        secondAboutContent
        secondAboutTitle
        secondAboutImage {
          url(transform: { width: 2400, quality: 70 })
        }
        infoOne
        locationOne
        locationTwo
        locationThree
        valueOne
        valueTwo
        valueThree
        valueFour
      }
    }
  }
`

export const useAboutPage = () => {
  const { data, error, loading, refetch } = useQuery(QUERY_ABOUT_PAGE, {
    client: client,
  })
  return {
    aboutPageContent: data?.aboutpageCollection,
    error: error,
    loading: loading,
    refetch,
  }
}
